import { Component, ChangeDetectionStrategy } from '@angular/core'
import { LOCALE_LABELS, SUPPORTED_LOCALES, SupportedLocale } from 'lib-trend-core'
import { LanguageService } from '../../i18n/language.service'

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LanguagePickerComponent {

  readonly locales: ReadonlyArray<SupportedLocale> = SUPPORTED_LOCALES
  readonly labels: Record<SupportedLocale, string> = LOCALE_LABELS

  constructor(public readonly languageService: LanguageService) { }

  get current(): SupportedLocale {
    return this.languageService.currentLang
  }

  select(locale: SupportedLocale): void {
    if (locale !== this.current) {
      this.languageService.setLanguage(locale)
    }
  }
}
